import type { FaireProductEntity } from "../../entity_types/product";

export const p_qvr3rd46xd: FaireProductEntity = {
  token: "p_qvr3rd46xd",
  type: "product",
  name: "Fudge Sampler Three Pack- plain, walnut, caramel",
  brandToken: "b_8326t3xrxv",
  brandName: "Flower Child Fudge",
  imageUrl:
    "https://cdn.faire.com/fastly/8033d72e86843038bea44adedaa1de08d6b9d8cac0dc8ab4815678d30bdc1b11.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e9d54595c80d3502def4998c12d85d55fabb4094f32a5c5119a0a35f376bc9d8.jpeg",
    "https://cdn.faire.com/fastly/0da852f333d6010d8353f9730d534a9c9ebc73b9a15dd65297c06f1ebdcb1ced.jpeg",
    "https://cdn.faire.com/fastly/1b5ecfd3bad30f948fd9ed4461337948ed17ef66f51cc139301546d7536a83ba.png",
    "https://cdn.faire.com/fastly/e9057a67b8034a66faeb226db1eca85e5920058856b040fe015cd39840083e9a.png",
    "https://cdn.faire.com/fastly/be3699bc20c071e4b1ce4b3051b40cda40b91292880b5d0a905f4abb3150b124.jpeg",
  ],
  priceDollars: 9.01,
  description:
    "This small-batch fudge is made with just a few real ingredients, sweetened only with dates, and entirely plant-based. Rich, smooth, and not too sweet — it’s a thoughtful take on a classic treat.\n\nEach sampler includes 5 pieces of each flavor:\n\nClassic Plain – simple and satisfying\nWalnut & Macadamia – with a bit of crunch\nTahini Caramel – earthy, sweet, and a little unexpected\n\nPacked in a handmade cloth bag and wrapped with plantable wildflower seed paper, it’s a treat that leaves nothing to waste.",
  tags: [],
  msrpDollars: 16.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:17.757Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
